import { render, staticRenderFns } from "./Loans.vue?vue&type=template&id=0b3db152&scoped=true&"
import script from "./Loans.vue?vue&type=script&lang=ts&"
export * from "./Loans.vue?vue&type=script&lang=ts&"
import style0 from "./Loans.vue?vue&type=style&index=0&id=0b3db152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3db152",
  null
  
)

export default component.exports